var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labelText"},[_c('canvas',{ref:"labelText"}),_c('div',{staticClass:"text"},[_vm._v("立即加入")])])
}
var staticRenderFns = []

export { render, staticRenderFns }